module.exports = {
	"data": {
		"allMarkdownRemark": {
			"edges": [
				{
					"node": {
						"id": "/Users/alex/Working/blog/data/posts/July_02_2017.md absPath of file >>> MarkdownRemark",
						"smallImage": {
							"image": {
								"childImageSharp": {
									"small": {
										"src": "/static/a2ea1ba28002f7cb2bb02f3de410e393.jpg",
										"srcSet": "/static/a2ea1ba28002f7cb2bb02f3de410e393-5b4c4.jpg 73w,\n/static/a2ea1ba28002f7cb2bb02f3de410e393-350dd.jpg 146w,\n/static/a2ea1ba28002f7cb2bb02f3de410e393.jpg 292w,\n/static/a2ea1ba28002f7cb2bb02f3de410e393-f792c.jpg 438w,\n/static/a2ea1ba28002f7cb2bb02f3de410e393-b65af.jpg 584w,\n/static/a2ea1ba28002f7cb2bb02f3de410e393-08024.jpg 876w,\n/static/a2ea1ba28002f7cb2bb02f3de410e393-ea0ea.jpg 2310w"
									}
								}
							}
						},
						"frontmatter": {
							"title": "Composeable Javascript Web",
							"path": "/posts/composeable-web",
							"summary": "The future is of the web will have faster JS in more places - It's things like ES6 and Typescript make excited to write JS again.",
							"date": "July 02, 2017"
						}
					}
				},
				{
					"node": {
						"id": "/Users/alex/Working/blog/data/posts/About.md absPath of file >>> MarkdownRemark",
						"smallImage": {
							"image": {
								"childImageSharp": {
									"small": {
										"src": "/static/a2ea1ba28002f7cb2bb02f3de410e393.jpg",
										"srcSet": "/static/a2ea1ba28002f7cb2bb02f3de410e393-5b4c4.jpg 73w,\n/static/a2ea1ba28002f7cb2bb02f3de410e393-350dd.jpg 146w,\n/static/a2ea1ba28002f7cb2bb02f3de410e393.jpg 292w,\n/static/a2ea1ba28002f7cb2bb02f3de410e393-f792c.jpg 438w,\n/static/a2ea1ba28002f7cb2bb02f3de410e393-b65af.jpg 584w,\n/static/a2ea1ba28002f7cb2bb02f3de410e393-08024.jpg 876w,\n/static/a2ea1ba28002f7cb2bb02f3de410e393-ea0ea.jpg 2310w"
									}
								}
							}
						},
						"frontmatter": {
							"title": "About",
							"path": "/about",
							"summary": "Because everyone writes a blog to be self indulgent.",
							"date": "July 02, 2017"
						}
					}
				}
			]
		}
	},
	"pathContext": {}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/index.json
// module id = ./node_modules/json-loader/index.js!./.cache/json/index.json
// module chunks = 7